// Grammar Questions - Original questions for SpeakUp Placement Test
// 30 questions covering A1 to C1 levels

export const grammarQuestions = [
  // A1 Level Questions (1-10)
  {
    id: 1,
    section: 'grammar',
    question: '_____ name is Maria.',
    options: ['My', 'I', 'Me', 'Mine'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 2,
    section: 'grammar',
    question: 'She _____ a teacher.',
    options: ['am', 'is', 'are', 'be'],
    correct: 1,
    level: 'A1'
  },
  {
    id: 3,
    section: 'grammar',
    question: 'Where _____ you from?',
    options: ['is', 'am', 'are', 'be'],
    correct: 2,
    level: 'A1'
  },
  {
    id: 4,
    section: 'grammar',
    question: 'I _____ two brothers.',
    options: ['have', 'has', 'am', 'is'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 5,
    section: 'grammar',
    question: 'They _____ to school every day.',
    options: ['goes', 'go', 'going', 'to go'],
    correct: 1,
    level: 'A1'
  },
  {
    id: 6,
    section: 'grammar',
    question: 'This is _____ book.',
    options: ['a', 'an', 'the', 'some'],
    correct: 0,
    level: 'A1'
  },
  {
    id: 7,
    section: 'grammar',
    question: '_____ do you live?',
    options: ['What', 'When', 'Where', 'Who'],
    correct: 2,
    level: 'A1'
  },
  {
    id: 8,
    section: 'grammar',
    question: 'She _____ English and Spanish.',
    options: ['speak', 'speaks', 'speaking', 'to speak'],
    correct: 1,
    level: 'A1'
  },
  {
    id: 9,
    section: 'grammar',
    question: 'There _____ a cat in the garden.',
    options: ['am', 'is', 'are', 'be'],
    correct: 1,
    level: 'A1'
  },
  {
    id: 10,
    section: 'grammar',
    question: 'I _____ like coffee.',
    options: ['no', 'not', "don't", "doesn't"],
    correct: 2,
    level: 'A1'
  },

  // A2 Level Questions (11-18)
  {
    id: 11,
    section: 'grammar',
    question: 'Yesterday, I _____ to the cinema.',
    options: ['go', 'goes', 'went', 'going'],
    correct: 2,
    level: 'A2'
  },
  {
    id: 12,
    section: 'grammar',
    question: 'She is _____ than her sister.',
    options: ['tall', 'taller', 'tallest', 'more tall'],
    correct: 1,
    level: 'A2'
  },
  {
    id: 13,
    section: 'grammar',
    question: 'I _____ been to Paris twice.',
    options: ['am', 'was', 'have', 'has'],
    correct: 2,
    level: 'A2'
  },
  {
    id: 14,
    section: 'grammar',
    question: 'They _____ watching TV right now.',
    options: ['is', 'am', 'are', 'be'],
    correct: 2,
    level: 'A2'
  },
  {
    id: 15,
    section: 'grammar',
    question: 'Can you help me _____ this bag?',
    options: ['carry', 'carrying', 'to carrying', 'carried'],
    correct: 0,
    level: 'A2'
  },
  {
    id: 16,
    section: 'grammar',
    question: 'I _____ see you tomorrow.',
    options: ['will', 'am', 'going', 'do'],
    correct: 0,
    level: 'A2'
  },
  {
    id: 17,
    section: 'grammar',
    question: "There aren't _____ people here today.",
    options: ['much', 'many', 'some', 'a lot'],
    correct: 1,
    level: 'A2'
  },
  {
    id: 18,
    section: 'grammar',
    question: 'She _____ cooking when I arrived.',
    options: ['is', 'was', 'were', 'has'],
    correct: 1,
    level: 'A2'
  },

  // B1 Level Questions (19-25)
  {
    id: 19,
    section: 'grammar',
    question: 'If I _____ you, I would study more.',
    options: ['am', 'was', 'were', 'be'],
    correct: 2,
    level: 'B1'
  },
  {
    id: 20,
    section: 'grammar',
    question: 'The report _____ by next Monday.',
    options: ['will finish', 'will be finished', 'finish', 'finishing'],
    correct: 1,
    level: 'B1'
  },
  {
    id: 21,
    section: 'grammar',
    question: 'I wish I _____ speak Chinese.',
    options: ['can', 'could', 'will', 'would'],
    correct: 1,
    level: 'B1'
  },
  {
    id: 22,
    section: 'grammar',
    question: 'She asked me _____ I wanted coffee.',
    options: ['that', 'if', 'what', 'why'],
    correct: 1,
    level: 'B1'
  },
  {
    id: 23,
    section: 'grammar',
    question: 'The book _____ I bought yesterday is fantastic.',
    options: ['who', 'which', 'what', 'where'],
    correct: 1,
    level: 'B1'
  },
  {
    id: 24,
    section: 'grammar',
    question: 'By the time you arrive, I _____ dinner.',
    options: ['finish', 'will finish', 'will have finished', 'finished'],
    correct: 2,
    level: 'B1'
  },
  {
    id: 25,
    section: 'grammar',
    question: "You _____ smoke in here. It's not allowed.",
    options: ["don't have to", "mustn't", "needn't", "shouldn't"],
    correct: 1,
    level: 'B1'
  },

  // B2 Level Questions (26-28)
  {
    id: 26,
    section: 'grammar',
    question: '_____ the bad weather, we decided to go hiking.',
    options: ['Despite', 'Although', 'However', 'Because'],
    correct: 0,
    level: 'B2'
  },
  {
    id: 27,
    section: 'grammar',
    question: 'I would rather you _____ tell anyone about this.',
    options: ["don't", "didn't", "won't", "wouldn't"],
    correct: 1,
    level: 'B2'
  },
  {
    id: 28,
    section: 'grammar',
    question: 'No sooner _____ the door than the phone rang.',
    options: ['I had opened', 'had I opened', 'I opened', 'did I open'],
    correct: 1,
    level: 'B2'
  },

  // C1 Level Questions (29-30)
  {
    id: 29,
    section: 'grammar',
    question: '_____ had she finished the project when another one was assigned.',
    options: ['Barely', 'Barely not', 'Not barely', 'Scarcely not'],
    correct: 0,
    level: 'C1'
  },
  {
    id: 30,
    section: 'grammar',
    question: 'The committee recommended that the proposal _____ immediately.',
    options: ['is implemented', 'be implemented', 'will be implemented', 'was implemented'],
    correct: 1,
    level: 'C1'
  }
];
